class Recruit {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    // PC版のみ、かつタブが3つ以上ある場合のみSwiperを適用
    if ($(window).innerWidth() >= 768) {
      $(".js-recruit-swiper").each(function () {
        const $swiper = $(this);
        const tabCount = $swiper.find(".c-job-description__tab-item").length;

        if (tabCount >= 3) {
          const RecruitSwiper = new Swiper($swiper[0], {
            direction: "horizontal",
            slidesPerView: "auto",
            allowTouchMove: true,
            simulateTouch: true,
            grabCursor: true,
          });
        }
      });
    }
  }
}

